import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Flame } from "lucide-react";

export default function StreakCard() {
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    // ping activity, then fetch streak
    api.post("/activity/ping").catch(() => {});
    api.get("/streak").then(r => setStreak(r.data)).catch(() => {});
  }, []);

  if (!streak) return null;

  const dots = [];
  const today = new Date();
  const dayLabels = ["S", "M", "T", "W", "T", "F", "S"];
  // Build last 7 days ending today
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    dots.push({
      date: d.toISOString().slice(0, 10),
      day: dayLabels[d.getUTCDay()],
    });
  }
  const lastActive = streak.last_activity;

  return (
    <Card className="p-6" data-testid="streak-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="label-caps">Study streak</div>
          <div className="flex items-baseline gap-2 mt-1">
            <div className="font-serif text-5xl leading-none" data-testid="streak-current">{streak.current}</div>
            <div className="text-sm text-muted-foreground">day{streak.current === 1 ? "" : "s"}</div>
          </div>
        </div>
        <div className="text-accent">
          <Flame size={32} strokeWidth={1.5} className={streak.current > 0 ? "" : "opacity-30"} />
        </div>
      </div>
      <div className="flex justify-between gap-1">
        {dots.map((dot, i) => {
          // Active if we have activity on that date — we only know last_activity + count, so we approximate by shading current streak backwards
          const active = i >= 7 - streak.current;
          return (
            <div key={i} className="flex flex-col items-center gap-1 flex-1">
              <div className={`h-8 w-full rounded-md ${active ? "bg-accent/80" : "bg-muted"}`} />
              <div className="text-[10px] text-muted-foreground font-mono">{dot.day}</div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 text-xs text-muted-foreground flex justify-between">
        <span>Longest: <strong className="text-foreground font-mono">{streak.longest}</strong></span>
        {lastActive && <span>Last: {lastActive}</span>}
      </div>
    </Card>
  );
}
